import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { t } from "i18next";
import { useEffect, useState } from "react";

export default function ModalCreateConquestMode({
    open,
    row,
    onClose,
    onSubmit
}: {
    open: boolean;
    row: any;
    onClose: () => void;
    onSubmit: (data: any) => void;
}) {
    const [rowsState, setRowsState] = useState<any[]>([]);

    useEffect(() => {
        if (row) setRowsState(row);
    }, [row]);

    const handleCellChange = (id: any, field: string, value: any) => {
        setRowsState((prev: any) =>
            prev.map((r: any) => (r.id === id ? { ...r, [field]: value } : r))
        );
    };

    const columns: GridColDef[] = [
        {
            field: "campaign_name",
            headerName: "Campaign",
            flex: 1,
            minWidth: 180,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "ad_group_name",
            headerName: "Ad Group",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "keyword",
            headerName: "Keyword",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "domain",
            headerName: "Competitor Domain name",
            flex: 1,
            minWidth: 180,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <TextField
                            fullWidth
                            value={params.row.domain || ""}
                            onChange={(e) => handleCellChange(params.id, "domain", e.target.value)}
                            size="small"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                sx: {
                                    borderRadius: '6px',
                                    border: '1px solid rgba(145, 158, 171, 0.16)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '80%',
                                    color: 'rgba(51, 60, 71, 1)',
                                    padding: '6px 8px',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        borderColor: 'rgba(0, 108, 156, 0.40)',
                                        backgroundColor: 'rgba(0, 108, 156, 0.03)',
                                        boxShadow: '0 0 0 2px rgba(51, 138, 243, 0.20)',
                                    },
                                },
                            }}
                        />
                    </Box>
                );
            },
        },
        {
            field: "strategy",
            headerName: "KPI",
            minWidth: 140,
            maxWidth: 240,
            editable: false,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            px: 0.5,
                            mt: .8
                        }}
                    >
                        <Autocomplete
                            size="small"
                                disablePortal={false} // ou supprime complètement cette ligne

                            options={["Paid First", "Paid Top"]}
                            value={params.row.strategy || ""}
                            onChange={(_, newValue) => handleCellChange(params.id, "strategy", newValue)}
                            sx={{
                                width: '100%',
                                '& .MuiAutocomplete-inputRoot': {
                                    minHeight: '38px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '0 8px',
                                    borderRadius: '6px',
                                    border: '1px solid rgba(145,158,171,0.16)',
                                    '&:hover': {
                                        borderColor: 'rgba(0,108,156,0.4)',
                                        backgroundColor: 'rgba(0,108,156,0.03)',
                                        boxShadow: '0 0 0 2px rgba(51,138,243,0.2)',
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    padding: 0,
                                    height: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                },
                                '& .MuiAutocomplete-endAdornment': {
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                },
                            }}
                            renderInput={(paramsInput) => (
                                <TextField
                                    {...paramsInput}
                                    variant="standard"
                                    InputProps={{
                                        ...paramsInput.InputProps,
                                        disableUnderline: true,
                                    }}
                                />
                            )}
                        />
                    </Box>
                );
            },
        },
        {
            field: "accepted_variation_threshold",
            headerName: "Threshold",
            flex: 1,
            minWidth: 120,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <TextField
                            type="number"
                            value={params.row.accepted_variation_threshold || ""}
                            onChange={(e) => handleCellChange(params.id, "accepted_variation_threshold", e.target.value)}
                            fullWidth
                            size="small"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                sx: {
                                    borderRadius: '6px',
                                    border: '1px solid rgba(145, 158, 171, 0.16)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '80%',
                                    color: 'rgba(51, 60, 71, 1)',
                                    padding: '6px 8px',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        borderColor: 'rgba(0, 108, 156, 0.40)',
                                        backgroundColor: 'rgba(0, 108, 156, 0.03)',
                                        boxShadow: '0 0 0 2px rgba(51, 138, 243, 0.20)',
                                    },
                                },
                            }}
                        />
                    </Box>
                );
            },
        },
        {
            field: "max_cpc",
            headerName: "Ceiling Max CPC",
            flex: 1,
            minWidth: 120,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <TextField
                            type="number"
                            value={params.row.max_cpc || ""}
                            onChange={(e) => handleCellChange(params.id, "max_cpc", e.target.value)}
                            fullWidth
                            size="small"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                sx: {
                                    borderRadius: '6px',
                                    border: '1px solid rgba(145, 158, 171, 0.16)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '80%',
                                    color: 'rgba(51, 60, 71, 1)',
                                    padding: '6px 8px',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        borderColor: 'rgba(0, 108, 156, 0.40)',
                                        backgroundColor: 'rgba(0, 108, 156, 0.03)',
                                        boxShadow: '0 0 0 2px rgba(51, 138, 243, 0.20)',
                                    },
                                },
                            }}
                        />
                    </Box>
                );
            },
        }
    ];

    return (
        <Dialog
            open={open && !!row}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    color: "#FFF",
                },
            }}
        >
            <DialogTitle sx={{
                padding: "24px",
                backgroundColor: '#f4f7fb'
            }}>
                <Typography
                    sx={{
                        color: '#333C47',
                        fontFamily: '"Public Sans"',
                        fontSize: '18px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '100%',
                    }}
                >
                    {`Add new keyword${row?.length > 1 ? 's' : ''}`}
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#f4f7fb' }}>
                <Box
                    sx={{
                        bgcolor: 'white',
                        "& .MuiDataGrid-columnHeader.keyword-header .MuiDataGrid-columnHeaderTitleContainer": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                        },

                        "& .MuiDataGrid-columnHeader.keyword-header .MuiDataGrid-columnHeaderTitleContainerContent": {
                            display: "flex",
                            flex: 1,
                        },
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: 'rgba(250, 251, 251)',
                            border: "1px solid #e9ecee",
                            height: '40px!important'
                        },
                        "& .keyword-header-wrapper": {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        },
                        position: "relative",
                        "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
                            outline: "none !important",
                        },
                        "& .MuiDataGrid-cell--pinnedLeft": {
                            backgroundColor: "white",
                        },
                        "& .MuiDataGrid-cell": {
                            borderBottom: "1px solid rgba(255,255,255,0.06)",
                            border: "1px solid #e9ecee"

                        },
                        "& .MuiDataGrid-row": {
                            borderBottom: "1px solid rgba(255,255,255,0.06)",
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            borderBottom: "1px solid rgba(255,255,255,0.10)",

                        },
                        "& .MuiDataGrid-columnSeparator": {
                            color: "rgba(255,255,255,0.12)",
                            visibility: "visible",
                        },

                        "& .MuiDataGrid-cell:not(:last-of-type)": {
                            borderRight: "1px solid rgba(255,255,255,0.06)",
                        },

                        "& .css-ly985t-MuiDataGrid-root .MuiTablePagination-toolbar": {
                            color: '#919EAB!important'
                        }
                    }}
                >
                    <DataGridPro
                        rows={rowsState || []}
                        columns={columns}
                        getRowId={(r) => r.id}
                        disableRowSelectionOnClick={true}
                        hideFooter
                        autoHeight
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ bgcolor: '#f4f7fb' }}>
                <Button variant="contained" color="inherit"
                    onClick={() => {
                        if (onSubmit) {
                            onSubmit(rowsState);
                        }
                        onClose();
                    }}
                    sx={{
                        borderRadius: '8px',
                        background: '#181818',
                        color: "rgba(255, 255, 255, 1)",
                        border: 'none',
                    }}>
                    {t('dashboard.global.brandPulse.activate')}
                </Button>

                <Button onClick={onClose} variant="outlined" color="inherit"
                    sx={{
                        borderRadius: '8px',
                        background: 'rgba(145, 158, 171, 0.12)',
                        color: "rgba(145, 158, 171, 1)",
                        border: 'none',
                    }}>
                    {t('dashboard.global.cancel')}
                </Button>
            </DialogActions>
        </Dialog >
    );
}